// src/pages/LandingPage.jsx
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';

import Header from '../components/Header/Header';
import IntroSection from '../sections/Intro/Intro';
import AboutSection from '../sections/About/About';
import DownloadSection from '../sections/Download/Download';



const scrollDebounce = 0;

export default function LandingPage() {
  const [active, setActive] = useState(1);
  const mainRef = useRef(null);


  useEffect(() => {
    const mainEl = mainRef.current;
    if (!mainEl) return;

    let timeoutId;

    const handleScroll = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        // Use the captured mainEl, not mainRef.current
        const scrollPos = mainEl.scrollTop;
        const sectionHeight = window.innerHeight;
        setActive(Math.round(scrollPos / sectionHeight));
      }, scrollDebounce);
    };

    // Initialize activeSection on mount
    handleScroll();
    mainEl.addEventListener('scroll', handleScroll);

    return () => {
      mainEl.removeEventListener('scroll', handleScroll);
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <div className="app" style={{ '--viewHeight': `${window.innerHeight}px` }}>
      <Header activeSection={active} showPagination={window.location.pathname  === '/'} />
      <main ref={mainRef}>
        <IntroSection />
        <AboutSection activeSlide={active} />
        <DownloadSection />
      </main>
    </div>
  );
}
